import React, { Component } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { connect } from 'react-redux'
import { createFilters } from '../reducers/managePublications'
import { Button, Glyphicon } from 'react-bootstrap'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

class ExportPublications extends Component {

  state = {
    downloadingPublications: false,
  }


  handleExportPublications = () => {
    if (this.state.downloadingPublications) {
      return
    }

    const { filters, sort_by } = createFilters(this.props)

    this.setState({ downloadingPublications: true })

    axios({
      url: `${getServerURL()}export-publications/`,
      method: 'GET',
      params: {
        filters,
        sort_by
      },
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("token")
      },
      responseType: 'blob',
    })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      const date = new Date().toJSON().split("T")[0].split('-')
      const formattedDate = `${date[1]}-${date[2]}-${date[0]}`
      link.setAttribute('download', `genesis-publications_${formattedDate}.xlsx`)
      this.setState({ downloadingPublications: false })
      swal({
        title: "Your file is ready",
        text: "Click the button to download",
        icon: "success",
        button: 'Download'
      })
      .then(() => {
        document.body.appendChild(link)
        link.click()
      })
    })
    .catch(error => {
      const message = "There was an error downloading your file."
      handleErrorFetchingData(error, message)
    })
  }

  render () {

    const { downloadingPublications } = this.state

    return (
      <Button
        disabled={downloadingPublications}
        onClick={this.handleExportPublications}
      >
        {downloadingPublications ?
          <Glyphicon
            glyph='refresh'
            style={{minWidth: '170px'}}
            className='rotate-btn'
          />
          :
          'Export Publications to Excel'
        }
      </Button>
    )
  }
}

const mapStateToProps = state => {
  return {
    // FILTERS & SORTING //
    publicationsSearchTerm: state.managePublications.publicationsSearchTerm,
    publicationsSortType: state.managePublications.publicationsSortType,
    publicationsApprovalStatusSortType: state.managePublications.publicationsApprovalStatusSortType,
    publicationsApprovalStatusFilter: state.managePublications.publicationsApprovalStatusFilter,
    publicationsAuthorFilter: state.managePublications.publicationsAuthorFilter,
    publicationsYearFilter: state.managePublications.publicationsYearFilter,
    publicationsClientFilter: state.managePublications.publicationsClientFilter,
    publicationsProductFilter: state.managePublications.publicationsProductFilter,
    publicationsIndicationFilter: state.managePublications.publicationsIndicationFilter,
    publicationsTherapeuticAreasFilter: state.managePublications.publicationsTherapeuticAreasFilter,
    publicationsStudyDesignsFilter: state.managePublications.publicationsStudyDesignsFilter,
    publicationsPublicationTypeFilter: state.managePublications.publicationsPublicationTypeFilter,
    publicationsMethodAnalysisTypesFilter: state.managePublications.publicationsMethodAnalysisTypesFilter,
    publicationsDataSourcesFilter: state.managePublications.publicationsDataSourcesFilter,
    publicationsDataSourceTypesFilter: state.managePublications.publicationsDataSourceTypesFilter,
    publicationsDoneWithGenesis: state.managePublications.publicationsDoneWithGenesis,
    publicationsRegulatoryRelated: state.managePublications.publicationsRegulatoryRelated,
  }
}

export default connect(mapStateToProps)(ExportPublications);



// WEBPACK FOOTER //
// ./src/routes/publications/components/ExportPublications.js